import React, { useState } from "react";
import {
  CommonMFE,
  ReactMFE,
  Helpers,
} from "@tpd-web-common-libs/nodejs-library";
/** Style */
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import {
  ContainerDiv,
  IFrameContainer,
  TpdControlPlay,
  TpdPlay,
} from "./App.style";
/** Components */
import YouTube, { YouTubePlayer } from "react-youtube";
import {
  BoxContentWrapper,
  getRgbaBoxColorBy,
  getRgbaBoxColorMobileBy,
} from "./BoxContentWrapper";
import { ImageWrapper } from "./ImageWrapper";

const App = (props: CommonMFE.Types.TProps) => {
  const { __host__, config, isEditMode, id: containerID } = props;
  const [play, setPlay] = useState(false);
  const coloreBox = Helpers.RemoteHelper.getSelectedValue(
    config["coloreBox"]?.value
  );

  const title = config["Title"];
  const previewImage = config["Preview"];
  const bgImage = config["Immagine"];

  const video = config["Video"];
  /** Get the Youtube Video ID from a YT URL
   * TODO: Check if we have more format in this field
   * Now we have 2 format:
   * 1) A youtube URL from which we take the youtube video ID with a regex
   * 2) Directly a Youtube Video ID
   */
  const youtubeID = Helpers.UrlHelper.getYoutubeId(video.value.value);
  const videoID: string = youtubeID ? youtubeID : video.value.value;
  let videoElement: YouTubePlayer = null;
  /** Video Options */
  const YTOptions = {
    height: "100%",
    width: "100%",
    playerVars: {
      autoplay: 1,
      rel: 0,
      enablejsapi: 1,
      showinfo: 0,
      playsinline: 1,
        origin: `https://${Helpers.BrandNameHelper.urlName()}.it`,
      widgetid: 1,
    },
  };
  const YTStyle = {
    height: "100%",
    width: "100%",
  };

  const onPlayCursorClick = () => setPlay(true);
  /** Youtube Events */
  const onPlayerReady = (event: YouTubePlayer) => {
    videoElement = event;
  };
  const onPlayVideo = () => setPlay(true);
  const onPauseVideo = () => setPlay(false);

  return (
    <ContainerDiv
      {...Helpers.RemoteHelper.getPrimaryRemoteContainerStyleData(config)}
      data-color-box={getRgbaBoxColorBy(coloreBox)}
      data-color-box-mobile={getRgbaBoxColorMobileBy(coloreBox)}
      data-box-margin-top={title.value && title.value.value ? "10%" : "80px"}
      className="tpd-visore-no-carosello-container"
    >
      <div className="image-wrapper">
        {video && videoID ? (
          <IFrameContainer>
            {play ? (
              <YouTube
                videoId={videoID}
                style={YTStyle}
                opts={YTOptions}
                onReady={onPlayerReady}
                onPlay={onPlayVideo}
                onEnd={onPauseVideo}
              />
            ) : (
              Helpers.EnvironmentHelper.isClientSide() &&
              <TpdControlPlay
                data-testid="play-cursor"
                onClick={onPlayCursorClick}
              >
                <TpdPlay />
              </TpdControlPlay>
            )}
            <ImageWrapper
              id={CommonMFE.generateID(containerID, `previewImage`)}
              __host__={__host__}
              isEditMode={isEditMode}
              image={previewImage}
            />
          </IFrameContainer>
        ) : (
          <ImageWrapper
            key={CommonMFE.generateID(containerID, `bgImage`)}
            id={CommonMFE.generateID(containerID, `bgImage`)}
            __host__={__host__}
            isEditMode={isEditMode}
            image={bgImage}
          />
        )}
      </div>
      {!play && (
        <BoxContentWrapper
          id={CommonMFE.generateID(containerID, `boxContent`)}
          __host__={__host__}
          isEditMode={isEditMode}
          config={config}
        />
      )}
    </ContainerDiv>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
